import React from 'react';
import { motion } from 'framer-motion';

export interface CardProps {
  title?: React.ReactNode;
  subtitle?: string;
  icon?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  interactive?: boolean;
  onClick?: () => void;
  animate?: boolean;
}

const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  icon,
  footer,
  children,
  className = '',
  interactive = false,
  onClick,
  animate = true,
}) => {
  const CardComponent = animate ? motion.div : 'div';
  
  const animationProps = animate ? {
    whileHover: interactive ? { y: -5, boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' } : {},
    transition: { type: 'spring', stiffness: 300 }
  } : {};

  return (
    <CardComponent
      className={`bg-white rounded-xl shadow-md p-6 ${interactive ? 'cursor-pointer' : ''} ${className}`}
      onClick={interactive ? onClick : undefined}
      {...animationProps}
    >
      {(title || icon) && (
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            {icon && (
              <div className="bg-avn-purple-100 p-3 rounded-lg">
                {icon}
              </div>
            )}
            <div>
              {title && (
                typeof title === 'string' 
                  ? <h3 className="text-lg font-semibold">{title}</h3>
                  : title
              )}
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
          </div>
        </div>
      )}
      
      <div>
        {children}
      </div>
      
      {footer && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          {footer}
        </div>
      )}
    </CardComponent>
  );
};

export default Card;